<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sharedStatus"
        placeholder="共享状态"
      >
        <el-option
          v-for="(item, i) in sharedData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="在线状态"
      >
        <el-option
          v-for="(item, i) in onlineList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <!--<el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.setTop"
        placeholder="是否置顶"
      >
        <el-option
          v-for="(item, i) in topList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>-->
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.newsTitle"
        placeholder="新闻标题"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      onlineList: [],
      topList: [],
      sharedData: []
    };
  },
  created() {
    this.getSysParamByTypes(["ONLINE_STATUS", "IS_VALID", "SHARED_SCREEN_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["IS_VALID"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["SHARED_SCREEN_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.onlineList = res.data["ONLINE_STATUS"];
        this.topList = res.data["IS_VALID"];
        this.sharedData = res.data["SHARED_SCREEN_STATUS"] || [];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
